// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"22cb44e0","198":"5fa18ce7","496":"66a76962","626":"b7e6ce8d","901":"bf3a420b","912":"ad3d2319","921":"7137c56b"}[chunkId] + ".chunk.js";
};